import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0031557d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mega-menu-content" }
const _hoisted_2 = { class: "mega-menu-column" }
const _hoisted_3 = { class: "mega-menu-title" }
const _hoisted_4 = {
  key: 0,
  class: "mega-menu-list"
}
const _hoisted_5 = { class: "mega-menu-sub" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mega-image-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      width: "100%",
      src: "https://images.unsplash.com/photo-1556912172-45b7abe8b7e1?w=400",
      alt: "Phòng khách"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "image-label cart-view btn-menu-sub" }, "PHÒNG KHÁCH")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mega-image-card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
    /*#__PURE__*/_createElementVNode("img", {
      width: "100%",
      src: "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=400",
      alt: "Gợi ý phòng bếp"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "image-label cart-view btn-menu-sub" }, "GỢI Ý PHÒNG BẾP")
], -1))

interface Props {
  megaMenu: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenu',
  props: {
    megaMenu: { default: () => [] }
  },
  setup(__props: any) {


const props = __props


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      gutter: 0,
      class: "mega-menu-row"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.megaMenu, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_col, {
            span: 4,
            class: "mega-col bordered-col",
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h4", _hoisted_3, _toDisplayString(item.linkLabel), 1),
                (item.children != null && item.children.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, cIndex) => {
                        return (_openBlock(), _createElementBlock("li", { key: cIndex }, [
                          _createVNode(_component_router_link, {
                            to: child.linkTo,
                            class: "nav-link"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_5, _toDisplayString(child.linkLabel), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_a_col, {
          span: 5,
          class: "mega-col padding-col"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          span: 6,
          class: "mega-col padding-col"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})